<template>
  <div>
    <v-navigation-drawer
      :rail="!sideBar"
      :rail-width="70"
      class="sidebar"
      floating
      :permanent="!$smallScreen"
      :temporary="$smallScreen"
      :model-value="$smallScreen ? navModel?.val : true"
      @update:model-value="$emit('update:navModel', { ...navModel, val: $event })"
    >
      <v-list density="compact">
        <div style="cursor:pointer; text-align: center; padding-top: 15px;" @click="setConfigPage('config')">
          <img
            v-if="sideBar"
            src="https://static.paymentiq.io/logo/PaymentIQ_Logomark_Black.svg"
            width="200px"
            alt="PaymentIQ logo">
          <img
            v-if="!sideBar"
            src="https://static.paymentiq.io/favicon_piq.png"
            width="45px"
            alt="PaymentIQ icon">
        </div>

        <div class="category">
          <h3 v-show="sideBar" @click="setConfigPage('config')">
            Cashier
          </h3>

          <div class="list-item-container" :key="c.name" v-for="c in cashierCategory">
            <v-list-item v-if="(!c.hidesmall && $smallScreen) || !$smallScreen" :class="{ 'active' : c.page === active }" @click="setConfigPage(c.page)" link>
              <template v-slot:prepend>
                <v-icon>{{ c.icon }}</v-icon>
              </template>
              <v-list-item-title>{{ c.name }}</v-list-item-title>
            </v-list-item>
          </div>
        </div>

        <div class="category">
          <h3 @click="setShowCasePageMethod('showcase')" v-show="sideBar">
            Showcase
          </h3>

          <div class="list-item-container" :key="item.name" v-for="item in showcaseCategories">
            <v-list-item v-if="(!item.hidesmall && $smallScreen) || !$smallScreen" :class="{ 'active' : item.page === active }" @click="setShowCasePageMethod(item.page)" link>
              <template v-slot:prepend>
                <v-icon>{{ item.icon }}</v-icon>
              </template>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </div>
        </div>

        <div class="category">
          <h3 @click="setUsagePageMethod('api')" v-show="sideBar">
            Usage
          </h3>

          <div class="list-item-container" :key="item.name" v-for="item in usageCategory">
            <v-list-item v-if="(!item.hidesmall && $smallScreen) || !$smallScreen" :class="{ 'active' : item.page === active }" @click="setUsagePageMethod(item.page)" link>
              <template v-slot:prepend>
                <v-icon>{{ item.icon }}</v-icon>
              </template>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </div>
        </div>

        <div class="category">
          <h3 @click="openDocs">
            <span v-show="sideBar">
              Documentation
            </span>
            <v-icon>mdi-open-in-new</v-icon>
          </h3>
        </div>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Sidebar',
  props: {
    navModel: { type: Object, required: false }
  },
  emits: ['update:navModel'],
  data: () => ({
    active: 'config',
    cashierCategory: [
      {
        name: 'Configs',
        page: 'config',
        icon: 'mdi-view-dashboard'
      },
      {
        name: 'Theme',
        page: 'theme',
        icon: 'mdi-format-color-fill',
        hidesmall: true
      },
      {
        name: 'Custom CSS',
        page: 'css',
        icon: 'mdi-table-edit',
        hidesmall: true
      }
    ],
    usageCategory: [
      {
        name: 'Codesnippets',
        icon: 'mdi-code-array',
        page: 'api'
      },
      {
        name: 'URL',
        icon: 'mdi-web',
        page: 'url',
        hidesmall: true
      },
      {
        name: 'JS API',
        icon: 'mdi-server',
        page: 'jsApi',
        hidesmall: true
      }
    ],
    showcaseCategories: [
      {
        name: 'Showcase',
        icon: 'mdi-spotlight',
        page: 'showcase',
        hidesmall: true
      },
      {
        name: 'Import',
        icon: 'mdi-upload',
        page: 'import'
      }
    ]
  }),
  computed: {
    ...mapState({
      sideBar: ({ config }) => config.sideBar
    })
  },
  methods: {
    ...mapMutations([
      'configTypeMutation',
      'setUsagePage',
      'setShowCasePage'
    ]),
    setUsagePageMethod (page) {
      this.active = page
      if (this.$route.path !== '/usage') {
        this.$router.push('/usage')
      }
      this.setUsagePage(page)
    },
    setConfigPage (page) {
      this.active = page
      if (this.$route.path !== '/configs') {
        this.$router.push('/configs')
        setTimeout(() => {
          this.configTypeMutation(page)
        }, 150)
      } else {
        this.configTypeMutation(page)
      }
    },
    setShowCasePageMethod (page) {
      this.active = page
      if (this.$route.path !== '/showcase') {
        this.$router.push('/showcase')
      }
      this.setShowCasePage(page)
    },
    openDocs () {
      window.open('https://docs.paymentiq.io/docs/apis_and_integration/cashier/')
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item-container {
  border-radius: 15px!important;
}
.category {
  cursor: pointer;
  padding: 15px;
  h3 {
    color: #47beaa;
    padding: 10px;
  }
  .v-list-item:not(.active):hover {
    background: #d0d0d0!important;
  }
}
.sidebar {
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 15px 0px!important;
}
.active .v-list-item-title,
.active .v-icon,
.active .v-list-item__prepend .v-icon,
.active .v-list-item__prepend i,
.active i.mdi,
.active i {
  color: #ffffff!important;
}
.v-list-item:not(.active):hover {
  background: #d0d0d0!important;
  // padding-left: 30px;
  // transform: scale(1.2);
  // transition: none 0s ease 1s;
  .v-icon,
  i {
    color: inherit!important;
  }
}
.v-list-item:not(.active) .v-list-item__content:hover,
.v-list-item:not(.active) .v-list-item-title:hover,
.v-list-item:not(.active) .v-list-item__action:hover {
  &::after, &::before {
    border-radius: 15px!important;
  }
  background: transparent!important;
  color: inherit!important;
  border-radius: 15px!important;
}
.v-list-item:not(.active) .v-icon,
.v-list-item:not(.active) i,
.v-list-item:not(.active):hover .v-icon,
.v-list-item:not(.active):hover i,
.v-list-item:not(.active) .v-icon:hover,
.v-list-item:not(.active) i:hover {
  color: rgba(0, 0, 0, 0.87)!important;
}
.v-list-item {
  border-radius: 15px!important;
  padding-top: 12px!important;
  padding-bottom: 12px!important;
}
.v-list-item-title,
.v-list-item .v-list-item-title,
.sidebar .v-list-item-title,
.v-list .v-list-item-title,
.v-navigation-drawer .v-list-item-title {
  font-size: 13px!important;
}
h3:hover,
span:hover {
  background: none!important;
  color: #39ab99!important;
}
.active {
  // background: #3dff89;
  //background: #d3a5fb;
  background: #46beab;
  border-radius: 15px!important;
  * {
    color: #ffffff!important;
  }
  i {
    opacity: 0!important;
  }
  &:hover {
    background: #46beab!important;
    .v-list-item-title {
      color: #ffffff!important;
    }
  }
  i {
      opacity: 1!important;
    }
}

// Rail (collapsed) state - center items
.v-navigation-drawer--rail .v-list-item {
  // justify-content: center!important;
  padding-left: 8px !important;
  min-height: 48px!important;
}
.v-navigation-drawer--rail .v-list-item__content {
  display: none!important;
}
.v-navigation-drawer--rail .v-list-item-title {
  display: none!important;
}
</style>
